import { ApiPropertyOptional } from '@nestjs/swagger';
import { IsOptional, IsString, MaxLength } from 'class-validator';

export class AnularRecepcionCompraDto {
  @ApiPropertyOptional({ description: 'Motivo de anulación' })
  @IsOptional()
  @IsString()
  @MaxLength(500)
  motivo?: string;
}
